import axios from 'axios'
import { endAdminSession, getAdminToken } from '../utils/functions/auth'

const urlBase = process.env.REACT_APP_URL_BACKEND_BASE

const authHeaders = () => {
  const token = getAdminToken()
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
}

const handleAuthResponse = response => {
  if (response?.data?.status === 401) {
    endAdminSession()
  }
  return response
}

const getAllSales = async (estado, pagina) => {
  let url = `${urlBase}${process.env.REACT_APP_URL_SALES}`
  url = url.replace(':accion', 'allSales')
  url = url.replace(':estado', encodeURIComponent(estado || 'todas'))
  url = url.replace(':pagina', encodeURIComponent(pagina || 1))

  const response = await axios.get(url, authHeaders())

  return handleAuthResponse(response)
}

const confirmPayment = async idVenta => {
  let url = `${urlBase}${process.env.REACT_APP_URL_SALES}`
  url = url.replace(':accion', 'confirmPayment')
  url = url.replace(':estado', '').replace(':pagina', '')

  const response = await axios.post(url, { idVenta }, authHeaders())

  return handleAuthResponse(response)
}

const deletePayment = async idVenta => {
  let url = `${urlBase}${process.env.REACT_APP_URL_SALES}`
  url = url.replace(':accion', 'deletePayment')
  url = url.replace(':estado', '').replace(':pagina', '')

  const response = await axios.post(url, { idVenta }, authHeaders())

  return handleAuthResponse(response)
}

export const saleService = {
  getAllSales,
  confirmPayment,
  deletePayment
}
